const EDM_FORM_ADD_CALCULATE_BUTTON_STYLE = { justifyContent: 'space-between' }
const EDM_FORM_DROPDOWN_STYLE = { width: '100%' }
const EDM_FORM_HEADER_DIVIDER_STYLE = { margin: '0px 12px 12px 12px 12px' }
const EDM_FORM_ITEM_BOX_STYLE = { width: '100%' }
const EDM_FORM_INPUT_STYLE = { width: '50%' }
const EDM_FORM_ITEM_STYLE = { marginBottom: '4px', width: '50%' }
const EDM_FORM_TEXT_STYLE = { margin: '0px 5px 5px 0px', width: '50%' }
const EDM_FORM_DIVIDER_STYLE = { margin: '12px' }
const EDM_FORM_REMOVE_BOX_STYLE = {
    marginTop: '16px',
    justifyContent: 'center',
}
const EDM_FORM_REMOVE_BUTTON_STYLE = { width: '100%' }
const PLACEMENT = 'edm-calculator-panel'

export const EDM_STEP_ITEM_TYPES = [
    'wire',
    'sinkerKnownRemoval',
    'sinkerNoKnownRemoval',
]

const EDM_TYPES = {
    WIRE: 'wire',
    SINKER: 'sinker',
}

const WIRE_KEYS = {
    GEAR_SUFFIX: '-gear',
    ROUGHNESS_CATEGORY_SUFFIX: '-roughness-category',
    CUT_PATH_SUFFIX: '-cut-path',
    PLATE_THICKNESS: '-plate-thickness',
}

const SINKER_KEYS = {
    KNOWN_REMOVAL_VOLUME_SUFFIX: '-known-removal-volume-suffix',
    ROUGHNESS_CATEGORY_SUFFIX: '-roughness-category',
    SETUPS_SUFFIX: '-setups',
    VOLUME_REMOVED_SUFFIX: '-volume-removed',
    DESIRED_FILLET_RADIUS_SUFFIX: '-desired-fillet-radius',
    STANDARD_FILLET_RADIUS_SUFFIX: '-standard-fillet-radius',
    LENGTH_OF_FILLET_SUFFIX: '-length-of-fillet',
}

const EDM_CALCULATOR_FORM_KEYS = {
    EDM_TYPE_SUFFIX: '-edm-type',
    ...WIRE_KEYS,
    ...SINKER_KEYS,
}

export {
    EDM_CALCULATOR_FORM_KEYS,
    EDM_FORM_ITEM_BOX_STYLE,
    EDM_FORM_ADD_CALCULATE_BUTTON_STYLE,
    EDM_FORM_DIVIDER_STYLE,
    EDM_FORM_DROPDOWN_STYLE,
    EDM_FORM_HEADER_DIVIDER_STYLE,
    EDM_FORM_INPUT_STYLE,
    EDM_FORM_ITEM_STYLE,
    EDM_FORM_TEXT_STYLE,
    EDM_FORM_REMOVE_BOX_STYLE,
    EDM_FORM_REMOVE_BUTTON_STYLE,
    EDM_TYPES,
    PLACEMENT,
}
